var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#3787FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 7.75C7.33579 7.75 7 8.08579 7 8.5C7 8.91421 7.33579 9.25 7.75 9.25H18.25C18.6642 9.25 19 8.91421 19 8.5C19 8.08579 18.6642 7.75 18.25 7.75H7.75ZM7.75 13.75C7.33579 13.75 7 14.0858 7 14.5C7 14.9142 7.33579 15.25 7.75 15.25H18.25C18.6642 15.25 19 14.9142 19 14.5C19 14.0858 18.6642 13.75 18.25 13.75H7.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 10.75C7.33579 10.75 7 11.0858 7 11.5C7 11.9142 7.33579 12.25 7.75 12.25H18.25C18.6642 12.25 19 11.9142 19 11.5C19 11.0858 18.6642 10.75 18.25 10.75H7.75ZM7.75 16.75C7.33579 16.75 7 17.0858 7 17.5C7 17.9142 7.33579 18.25 7.75 18.25H18.25C18.6642 18.25 19 17.9142 19 17.5C19 17.0858 18.6642 16.75 18.25 16.75H7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListActive);
export default __webpack_public_path__ + "static/media/list-active.f5213dfb2198f7ed738891c34a5a9df2.svg";
export { ForwardRef as ReactComponent };